import { FaBasketShopping, FaBoxArchive } from "react-icons/fa6";
import { BsPersonVcardFill } from "react-icons/bs";
import { FaUserCircle } from "react-icons/fa";

export const features = [
  {
    icon: <FaBoxArchive />,
    title: "ڕێڤەبرنا کەرەستان",
    description: "پاراستن, رێڤەبرن و پولین کرنا کەرەستان دگەل دیف چوون و ئاگەهداریا نەمانێ ب شێوەکێ پێشکەفتی.",
  },
  {
    icon: <FaBasketShopping />,
    title: "کرین و فروتن",
    description: "فروتن و کرینەکا بلەز و ساناهی, چێکرنا وەسلان لدیف دلێ تە دێ کارێ تە بەرەڤ پێشڤە بەتن.",
  },
  {
    icon: <BsPersonVcardFill />,
    title: "ڕێڤەبرنا هژمارا لایەنێن بەرامبەر",
    description: "دەرئێخستنا حساباتێن کڕیار و دابینکەرێن تە بتنێ ب چەند چرکا و بێ سەرگێژێ دێ دەمەکێ زور بوتە زڤرینیت.",
  },
  {
    icon: <FaUserCircle />,
    title: "رێڤەبرنا بکارهێنەران",
    description: "تایبەتمەندیا چەند بکارهێنەری و دیارکرنا روڵێ هەر بکارهێنەرەکێ دێ چاڤدێریکرن لسەر چالاکیێن کارمەندێن تە ساناهی تر لێکەت",
  },
];
